import {useState, useEffect, useContext} from "react"
import UtilitySelect from "./UtilitySelect"
import ClientSelect from "./ClientSelect"
import MappingsEditor from "./MappingsEditor"
import axiosAuth from "../../../utils/axiosWithAuth"
import { useUser } from "../../../contexts/UserContext"
import TextractContext from "../../../contexts/TextractContext"

export default ({}) => {
  const {CLIENTS} = useContext(TextractContext)
  const [utilities, setUtilities] = useState([])
  const [selectedUtility, setSelectedUtility] = useState(null)
  const [selectedClient, setSelectedClient] = useState(null)
  const {user} = useUser()
  const [mappings, setMappings] = useState({
    chargeMappings: [],
    usageMappings: []
  })

  useEffect( _ => {
    if (!selectedUtility) return
    const allMappings = [...mappings.chargeMappings, ...mappings.usageMappings]
    if (allMappings.every(m => m.ack) && selectedUtility.has_unmapped) {
      const newUtility = {...selectedUtility, has_unmapped: false}
      setUtilities([...utilities.filter(u => u.id != selectedUtility.id), newUtility].sort((a,b) => a.name - b.name))
    }
  }, [mappings])

  useEffect(_ => {
    axiosAuth().get(`${user.admin ? "/admin/textract_bills" : "/documents"}/mappings/utilities`)
      .then(r => setUtilities(r.data.utilities))
      .catch(err => console.log(err.response))
  }, [])

  useEffect(_ => {
    if (selectedUtility) {
      axiosAuth().get(`${user.admin ? "/admin/textract_bills" : "/documents"}/mappings/utility/${selectedUtility.id}${selectedClient ? `?company_id=${selectedClient.id}` : ``}`)
        .then(r => setMappings(r.data.line_items))
        .catch(err => console.log(err.response))
    }
  }, [selectedUtility,selectedClient])
  return (
    <div className="mappings-pane">
      <UtilitySelect 
        utilities={utilities}
        selectedUtility={selectedUtility}
        setSelectedUtility={setSelectedUtility}
        />
      {user.admin && <ClientSelect 
        clients={CLIENTS}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
      />}
      <MappingsEditor
        mappings={mappings}
        setMappings={setMappings}
      />
    </div>
    // company selector
    // list with charge/usage defs dropdowns
    
    )
  }